import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function TeacherRating() {
  const { t } = useTranslation();
  const { detailTeacher } = useSelector((state) => state.companyManagerReducer);

  return (
    <div className="rating-box">
      <div className="teacher-info">
        <h2>{detailTeacher?.name}</h2>
        <p>Native language: {detailTeacher?.nativeLanguage}</p>
        <p>Country: {detailTeacher?.country}</p>
      </div>
      <div className="teacher-rating">
        <h2>{t("AVARAGE_RATING")}</h2>
        <p>
          <span className="rating">{detailTeacher?.rating}</span>
        </p>
      </div>
    </div>
  );
}

export default TeacherRating;
